import { FadeUp, MaskLines } from "../site/Reveal";

const Tile = ({ src, title, text, className = "", testid, delay }) => (
  <FadeUp delay={delay} className={`group relative min-h-[300px] overflow-hidden bg-white ${className}`} data-testid={testid}>
    <img src={src} alt={title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-6 text-white md:p-8">
      <p className="font-display text-2xl md:text-3xl">{title}</p>
      <p className="mt-2 max-w-xs text-sm text-[#E4E4E6]">{text}</p>
    </div>
  </FadeUp>
);

export const FeaturesBento = () => (
  <section className="bg-ivory py-24 md:py-36" data-testid="features-section">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10">
      <div className="mb-12 grid gap-6 md:mb-16 lg:grid-cols-2 lg:items-end">
        <div>
          <p className="label-mono">Design & features</p>
          <MaskLines inView lines={["Considered in", <em key="e">every detail.</em>]} className="mt-4 font-display text-5xl font-light leading-[0.92] text-ink md:text-7xl" />
        </div>
        <FadeUp className="max-w-md text-sm leading-relaxed text-graphite lg:justify-self-end">
          A clean rounded body, a full wraparound zip and an interior that keeps your essentials in place — finished with the silver MARKHOR emblem.
        </FadeUp>
      </div>
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[340px_340px]">
        <Tile testid="feature-interior" src="/img/v-inside.webp" title="Spacious & organized" text="Room for phone, wallet, keys and earbuds, with slip pockets, a zip pocket and mesh storage." className="md:col-span-2 lg:row-span-2 min-h-[420px]" />
        <Tile testid="feature-zip" src="/img/v-zip.webp" title="Premium zipper pull" text="A wide-opening wraparound zip with an engraved metal MARKHOR pull." delay={0.05} />
        <FadeUp delay={0.1} className="flex min-h-[300px] flex-col justify-between bg-night p-8 text-ivory" data-testid="feature-dimensions">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#A1A1A6]">Dimensions</p>
          <div>
            <p className="font-display text-6xl font-light leading-none">19 <span className="text-2xl">cm</span></p>
            <p className="mt-1 text-sm text-[#C9C9CC]">Width</p>
            <p className="mt-5 font-display text-6xl font-light leading-none">13 <span className="text-2xl">cm</span></p>
            <p className="mt-1 text-sm text-[#C9C9CC]">Height · 1 L volume</p>
            <p className="mt-5 border-t border-white/10 pt-4 text-sm text-[#E4E4E6]">Water-repellent fabric</p>
          </div>
        </FadeUp>
        <Tile testid="feature-emblem" src="/img/v-emblem.webp" title="Signature metal logo" text="A small, polished metal MARKHOR coin on every bag." delay={0.05} />
        <Tile testid="feature-strap" src="/img/v-strap.webp" title="Adjustable strap" text="MARKHOR quick-release buckle. Waist, chest or shoulder in seconds." delay={0.1} />
      </div>
    </div>
  </section>
);
